'use client';
import { classNames } from 'primereact/utils';
import { useState } from 'react';
import { PriceInfo } from './products';

export const GroupList = ({ data, price }) => {

    const [isActive, setIsActive] = useState(data && Array.isArray(data) && data[0]?.id);
    const [isActiveProduct, setIsProduct] = useState();
    const group = data.find(x => x?.id === isActive);

    return (<div>
        {!isActiveProduct &&
            <div className='mb-3'><div className='flex mb-1 align-items-center justify-content-center surface-10 p-2 w-18rem border-round-sm text-teal-500'>Price Range:  {price}</div>
                <small>Click each item to see price</small>
            </div>
        }

        {isActiveProduct && <div className='mb-4'>
            <PriceInfo price={isActiveProduct?.price} offer={isActiveProduct?.offer} mrp ={isActiveProduct?.mrp}/>
        </div>}
        <div className='flex flex-row gap-3 flex-wrap mb-4'>

            {group && group?.list?.map((x, i) => {
                return (<div key={i} onClick={() => setIsProduct(x)} className={classNames({ 'surface-0': (isActiveProduct?.id === x?.id) }, 'flex align-items-center justify-content-center border-1 border-100  p-2 pl-3 pr-3 hover:surface-100 border-round-sm cursor-pointer ')}> {x?.title}</div>)
            })}
        </div>

        <div className="flex gap-2 ">
            {data.map((x, i) => (<div key={i} onClick={() => setIsActive(x?.id)} className={classNames({ 'surface-100': isActive === x?.id }, "border-1 flex border-round-md align-items-center justify-content-center border-0 h-3rem w-6rem gap-2 cursor-pointer hover:surface-100")}> <div style={{ backgroundColor: x?.colorCode }} className="w-1rem h-1rem border-round-sm"></div> {x?.title}</div>))}
        </div>


    </div>)
}